import { RatingConfig } from "constants/ratings";
import ITrainer, { TrainerTypes } from "types/Trainer";

function* combine<T>(array: T[], n: number, start = 0, prev: T[] = []): Generator<T[]> {
  if (n <= 0) {
    yield prev;
    return;
  }

  for (let i = start; i <= array.length - n; i++) {
    yield* combine(array, n - 1, i + 1, [...prev, array[i]]);
  }
}

const getFirstValid = <T>(...values: T[]) => {
  return values.find((value) => typeof value !== "undefined");
};

const splitToChunks = <T>(array: T[], chunks: number): T[][] => {
  const result = [];
  const _array = [...array];

  for (let i = chunks; i > 0; i--) {
    result.push(_array.splice(0, Math.ceil(_array.length / i)));
  }
  return result;
};

const countOcurrences = <T extends string | number>(array: T[]): { [key in T]: number } => {
  return array.reduce((accum, curr) => {
    accum[curr] = accum[curr] || 0;
    accum[curr] += 1;

    return accum;
  }, {} as { [key in T]: number });
};

const sum = (array: number[]): number => {
  return array.reduce((accum, curr) => accum + curr, 0);
};

const updateTrainers = (trainers: ITrainer[], selected: ITrainer[]) => {
  return trainers.map((trainer) => {
    const _trainer = selected.find((t) => t.name === trainer.name);

    if (!_trainer) {
      return trainer;
    } else {
      return _trainer;
    }
  });
};

const facilityReward = {
  1: 10,
  2: 15,
  3: 20,
};

const getTrainingReward = (trainers: ITrainer[], nTrainers: number, facilityLevel: number, type: TrainerTypes) => {
  const devBonuses = trainers.flatMap((trainer) => trainer.devBonus[trainer.level]);

  const spTrainingRewards = devBonuses
    .filter((bonus) => bonus.includes("Sp. Training Reward"))
    .map((curr) => {
      const [_, valueWithPercent] = curr.split("+");
      const [value] = valueWithPercent.split("%");

      return Number(value);
    })
    .sort((a, b) => b - a)
    .slice(0, nTrainers);

  const spTrainingsRewardsTotal = (Utils.sum(spTrainingRewards) + 100) / 100;

  const trainingRewards = devBonuses
    .filter((bonus) => bonus.includes(`Training Reward (${type})`))
    .map((curr) => {
      const [_, value] = curr.split("+");

      return Number(value);
    })
    .sort((a, b) => b - a)
    .slice(0, nTrainers);

  const trainingRewardsTotal = Utils.sum(trainingRewards);

  const allTrainingRewards = devBonuses
    .filter((bonus) => bonus.includes(`Training Reward (All)`))
    .map((curr) => {
      const [_, valueWithPercent] = curr.split(`+`);
      const [value] = valueWithPercent.split("%");

      return Number(value);
    })
    .sort((a, b) => b - a)
    .slice(0, nTrainers);

  const allTrainingRewardsTotal = (Utils.sum(allTrainingRewards) + 100) / 100;

  const total =
    (facilityReward[facilityLevel] + trainingRewardsTotal) *
    spTrainingsRewardsTotal *
    allTrainingRewardsTotal *
    ((nTrainers * 5 + 100) / 100);

  return total;
};

const Utils = {
  combine,
  getFirstValid,
  splitToChunks,
  countOcurrences,
  sum,
  updateTrainers,
  getTrainingReward,
};

export default Utils;
